import { useQuery } from "@tanstack/react-query";

import { apiClient, getQueryKey } from "app/modules/api-client";
import { isResourceNotFoundError } from "app/services/fetchService";

import { getSecondaryListClaims } from "../utils/getSecondaryListClaims";

import { useAlertsParams } from "./useAlertsParams";

export const useSecondaryDomains = () => {
    const { activationId } = useAlertsParams();
    const { isEnabled } = getSecondaryListClaims();

    const { data, isLoading } = useQuery({
        queryKey: getQueryKey({
            tag: "Alerts",
            methodName: "userdataActivationAlertsSecondaryDomainsDetail",
            args: [activationId],
        }),
        queryFn: async () => {
            try {
                return await apiClient.Alerts.userdataActivationAlertsSecondaryDomainsDetail(activationId);
            } catch (error) {
                if (
                    isResourceNotFoundError(error)
                ) {
                    return null;
                }

                throw error;
            }
        },
        enabled: isEnabled,
    });

    return {
        domains: data?.domains ?? [],
        isLoading: isEnabled ? isLoading : false,
    };
};
